export const portalTitles = {
  PT: {
    signInAzure: 'Entre usando AzureAD',
    forgotPassword: 'Esqueceu a senha?',
    orWord: 'ou',
    startPage: 'Início',
    apps: 'Aplicações',
    // UserMenu
    selectProfileImage: 'Selecionar imagem de perfil',
    selectCompanyCode: 'Selecionar CNPJ',
    signOut: 'Sair',
    selectCompanyImage: 'Selecionar imagem da empresa',
    selectCompanyPhrase: 'Selecione o CNPJ da empresa desejada:'
  },
  EN: {
    signInAzure: 'Sign in using Azure',
    forgotPassword: 'Forgot your password?',
    orWord: 'or',
    startPage: 'Start',
    apps: 'Apps',
    // UserMenu
    selectProfileImage: 'Select profile image',
    selectCompanyCode: 'Select company code',
    signOut: 'Sign out',
    selectCompanyImage: 'Select company image',
    selectCompanyPhrase: 'Select your company code:'
  }
};
